'use client';

import { Box, css } from '@terra/ui-styled-system';
import { useId } from 'react';

const frameClassName = css({
  position: 'relative',
  width: 'full',
  maxW: '310px',
  height: '132px',
  overflow: 'hidden',
  pointerEvents: 'none',
  flexShrink: 0,
});

export function CopilotEmptyGlow() {
  return (
    <Box className={frameClassName} aria-hidden>
      <CopilotEmptyGlowGraphic />
    </Box>
  );
}

function CopilotEmptyGlowGraphic() {
  const id = useId().replace(/:/g, '');
  const clipId = `${id}-clip`;
  const filterOrangeId = `${id}-filter-orange`;
  const filterSandId = `${id}-filter-sand`;

  return (
    <svg
      width="310"
      height="132"
      viewBox="0 0 310 132"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      <g clipPath={`url(#${clipId})`}>
        <g filter={`url(#${filterOrangeId})`}>
          <circle
            cx="154.857"
            cy="149.272"
            r="111.137"
            transform="rotate(0.0700636 154.857 149.272)"
            fill="#E53A06"
          />
        </g>
        <g
          filter={`url(#${filterSandId})`}
          style={{ mixBlendMode: 'plus-lighter' }}
        >
          <circle
            cx="154.856"
            cy="164.455"
            r="88.7024"
            transform="rotate(0.0700636 154.856 164.455)"
            fill="#CCBC74"
          />
        </g>
        <circle
          cx="154.692"
          cy="297.797"
          r="224.971"
          transform="rotate(0.0700636 154.692 297.797)"
          fill="var(--colors-bg-default)"
        />
      </g>
      <defs>
        <filter
          id={filterOrangeId}
          x="10.7627"
          y="5.17861"
          width="288.188"
          height="288.188"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="16.4786"
            result="effect1_foregroundBlur"
          />
          <feTurbulence
            type="fractalNoise"
            baseFrequency="3.6410934925079346 3.6410934925079346"
            stitchTiles="stitch"
            numOctaves={3}
            result="noise"
            seed={4216}
          />
          <feColorMatrix
            in="noise"
            type="luminanceToAlpha"
            result="alphaNoise"
          />
          <feComponentTransfer in="alphaNoise" result="coloredNoise1">
            <feFuncA
              type="discrete"
              tableValues="0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
            />
          </feComponentTransfer>
          <feComposite
            operator="in"
            in2="effect1_foregroundBlur"
            in="coloredNoise1"
            result="noise1Clipped"
          />
          <feFlood floodColor="#E65C32" result="color1Flood" />
          <feComposite
            operator="in"
            in2="noise1Clipped"
            in="color1Flood"
            result="color1"
          />
          <feMerge result="effect2_noise">
            <feMergeNode in="effect1_foregroundBlur" />
            <feMergeNode in="color1" />
          </feMerge>
        </filter>
        <filter
          id={filterSandId}
          x="33.1963"
          y="42.7953"
          width="243.319"
          height="243.319"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="16.4786"
            result="effect1_foregroundBlur"
          />
          <feTurbulence
            type="fractalNoise"
            baseFrequency="3.6410934925079346 3.6410934925079346"
            stitchTiles="stitch"
            numOctaves={3}
            result="noise"
            seed={4216}
          />
          <feColorMatrix
            in="noise"
            type="luminanceToAlpha"
            result="alphaNoise"
          />
          <feComponentTransfer in="alphaNoise" result="coloredNoise1">
            <feFuncA
              type="discrete"
              tableValues="0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
            />
          </feComponentTransfer>
          <feComposite
            operator="in"
            in2="effect1_foregroundBlur"
            in="coloredNoise1"
            result="noise1Clipped"
          />
          <feFlood floodColor="#E65C32" result="color1Flood" />
          <feComposite
            operator="in"
            in2="noise1Clipped"
            in="color1Flood"
            result="color1"
          />
          <feMerge result="effect2_noise">
            <feMergeNode in="effect1_foregroundBlur" />
            <feMergeNode in="color1" />
          </feMerge>
        </filter>
        <clipPath id={clipId}>
          <rect
            width="309.797"
            height="131.035"
            fill="white"
            transform="translate(0.160234) rotate(0.0700636)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
